import { observable, action } from 'mobx';
import Jink from '@streaming/jink';


class Cam2CamStore {
  @observable c2cPreviewStream = null;
  @observable c2cError = '';
  @observable viewerJinkInstance = null;
  @observable initialLoading = true;

  @action setC2cPreviewStream = (value) => {
    this.c2cPreviewStream = value;
  };

  @action setInitialLoadingValue = (value) => {
    this.initialLoading = value;
  };

  @action setC2cError = (error) => {
    this.c2cError = error;
  };

  @action initializeJinkInstance = () => {
    if (this.viewerJinkInstance === null) {
      this.viewerJinkInstance = new Jink();
    }
  };
}

export default new Cam2CamStore();
